import { useGetTxInitData } from '@/hooks/tx'
import { useEstimateFee, useLoopedFeeLevel } from '@/hooks/tx'
import { useState, useEffect } from 'react'
import { memo } from 'react'
import GasSetting, { GasSettingData } from '../AssetWalletDetail/components/SendDrawer/GasSetting'
import { FeeRateDto, CreateSpeedTxDTO } from '@/services/apis/tx/models'
import riskApi from '@/services/apis/risk'
import { DestinationTypeEnum } from '@/constants/enum'
import { getLevelFeeRate } from '@/utils/fee'
import { useTranslation } from '@/services/i18n'
import txApi from '@/services/apis/tx'
import { AddPointDTO } from '@/services/apis/risk/models'
interface outputItem {
  address: string
  value: string
}
export enum TransactionTypeEnum {
  UTXO = 6,
}
export interface TxRecord {
  coinKey: string
  walletKey: string
  destinationAddress: string
  destinationId: string
  sourceId: string
  sourceAddress: string
  isRbf: boolean
  amount: string
  destinationType: DestinationTypeEnum
  txHash: string
  coinImplTag: string
  transactionType: TransactionTypeEnum
  outputs: outputItem[]
}

// interface QiankunGlobalState {
//   openGasSetting: boolean
//   refreshTxRecords: number
//   txRecord: TxRecord
// }
interface ChildProps {
  open?: boolean
  onClose?: Function
  txRecord?: TxRecord
  refresh?: Function
}
const TxSpeed = (props: ChildProps) => {
  const { open = false, onClose, txRecord, refresh } = props
  const { t } = useTranslation()
  // const [isOpened, setIsOpened] = useState(false)
  // const [txRecord, setTxRecord] = useState<TxRecord>()
  const [isSpeeding, setIsSpeeding] = useState(false)
  const [copyTxRecord, setCopyTxRecord] = useState<TxRecord>()
  useEffect(() => {
    setCopyTxRecord(txRecord)
  }, [txRecord])
  const {
    coinKey = '',
    walletKey = '',
    destinationAddress = '',
    sourceId = '',
    sourceAddress,
    txHash,
    isRbf = true,
    amount = '',
    destinationType = '',
    destinationId = '',
    coinImplTag = '',
    transactionType,
    outputs,
  } = copyTxRecord || {}

  // 获取交易初始数据
  const { feeRateLevelDto: initFeeLevelModel, expression } =
    useGetTxInitData(coinKey, walletKey, destinationAddress) || {}
  // 预估手续费
  const { estimateFee } = useEstimateFee(coinKey)
  // 实时刷新手续费
  const { feeLevelModel, timer, countDown } = useLoopedFeeLevel({
    coinKey,
    sourceAddress,
    replaceTxHash: txHash,
    destinationAddress,
  })
  // 关闭手续费定时器
  useEffect(() => {
    if (!open && timer.current) {
      clearInterval(timer.current)
    }
  }, [open, timer.current])
  const onOk = async (data: GasSettingData) => {
    setIsSpeeding(true)
    // 风控埋点
    const isCpfp = coinImplTag === 'utxo' && !isRbf
    let toAddress = ''
    if (isCpfp) {
      toAddress = sourceId
    } else if (destinationType === DestinationTypeEnum.VAULT_ACCOUNT) {
      toAddress = destinationId
    } else {
      toAddress = destinationAddress
    }
    let riskParams: AddPointDTO = {} as any
    // Rbf加速并且为utxo的批量
    if (isRbf && transactionType === 6) {
      riskParams = {
        coin_key: coinKey,
        amount: isCpfp ? '0' : amount,
        to_address: toAddress,
        address_type: destinationType === DestinationTypeEnum.VAULT_ACCOUNT ? 2 : 1,
        outputs: outputs,
      }
    } else {
      riskParams = {
        coin_key: coinKey,
        amount: isCpfp ? '0' : amount,
        to_address: toAddress,
        address_type: destinationType === DestinationTypeEnum.VAULT_ACCOUNT ? 2 : 1,
      }
    }

    const riskRes = await riskApi.addPoint(riskParams)
    if (!riskRes.success || !riskRes.data) {
      setIsSpeeding(false)
      return
    }
    const feeRateDto =
      data.feeType === 'level'
        ? getLevelFeeRate(data.feeLevel!, feeLevelModel || initFeeLevelModel)
        : data.feeRate
    const params: CreateSpeedTxDTO = {
      coinKey,
      feeRateDto: feeRateDto!,
      riskNo: riskRes.data,
      replaceTxHash: txHash!,
      feeLevel: data.feeType === 'level' ? data.feeLevel?.toLowerCase() : undefined,
    }
    const res = await txApi.createSpeedTx(params)
    setIsSpeeding(false)
    if (res.success) {
      window.shMessage.success(t('wallet.sendDrawer.txSpeedSuccess'))
      onClose && onClose()
      refresh && refresh()
    }
  }
  return (
    <GasSetting
      countDown={countDown}
      open={open}
      onClose={onClose as any}
      coinKey={coinKey}
      onOk={onOk}
      feeLevelModel={feeLevelModel || initFeeLevelModel}
      estimateFee={(feeRate?: FeeRateDto) => estimateFee(feeRate, expression)}
      isSpeeding={isSpeeding}
    />
  )
}

export default memo(TxSpeed)
